module.exports = __webpack_public_path__ + "7faa44b911d631e0ddd89680492c0605.gif";